var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WrapBg',{attrs:{"title":"","bgImg":"myBg"}},[_c('div',[_vm._v("密码设置结果")]),_c('div',{staticClass:"cdPasswordResult"},[_c('i',{staticClass:"el-icon-success text-success"}),_c('div',[_vm._v(_vm._s(_vm.result))])])])}
var staticRenderFns = []

export { render, staticRenderFns }